"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Phone = function Phone() {
	return _react2.default.createElement(
		"g",
		{ id: "Phone" },
		_react2.default.createElement("path", { d: "M100 216.667C138.89 294.444 205.556 358.333 283.333 400l61.11-61.11c8.335-8.334 19.446-11.112 27.78-5.557 30.555 11.11 63.888 16.667 100 16.667C488.888 350 500 361.11 500 377.778v94.444C500 488.89 488.89 500 472.222 500 211.112 500 0 288.89 0 27.778 0 11.11 11.11 0 27.778 0H125c16.667 0 27.778 11.11 27.778 27.778 0 33.333 5.555 66.666 16.666 100 2.778 8.333 0 19.444-5.555 27.778L100 216.666z" })
	);
};

exports.default = Phone;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-icon/Icons/Phone.js
// module id = 2975
// module chunks = 4